import { authHeader, handleResponse } from '../helpers';
export const DemappingRptService = {
    fetchDemappingData   
};

function fetchDemappingData(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };

    return fetch(`${process.env.REACT_APP_API_URL}DeMapping/GetDamapping`, requestOptions)
    .then(handleResponse);
}